import React, { useEffect, useState } from 'react';
import { createUmi } from '@metaplex-foundation/umi-bundle-defaults';
import { dasApi } from '@metaplex-foundation/digital-asset-standard-api';

const CollectionView = () => {
    const endpoint = process.env.REACT_APP_RPC_ENDPOINT; // Replace with your actual endpoint
    const collection = 'SeJbqGp2AHUyHR2o4TcFhWeqUvjH4vKULq4cb57aeTm';
    const [assets, setAssets] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchAssets = async () => {
            try {
                const umi = createUmi(endpoint).use(dasApi());
                const response = await umi.rpc.getAssetsByGroup({
                    groupKey: 'collection',
                    groupValue: collection,
                });

                if (response.items.length === 0) {
                    throw new Error('No assets found for the specified collection.');
                }

                setAssets(response.items);
            } catch (err) {
                setError(err.message || 'An unknown error occurred.');
            } finally {
                setLoading(false);
            }
        };

        fetchAssets();
    }, [endpoint, collection]);

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error}</p>;

    return (
        <div>
            <h1>Assets Viewer</h1>
            {assets.length > 0 ? (
                <ul>
                    {assets.map((asset, index) => (
                        <li key={index}>{JSON.stringify(asset)}</li>
                    ))}
                </ul>
            ) : (
                <p>No assets found for this collection.</p>
            )}
        </div>
    );
};

export default CollectionView;
